import cx from "classnames";
import { type HTMLProps, type Ref, forwardRef } from "react";

import bug from "assets/img/metabot-bug-report.svg?component";
import cloud from "assets/img/metabot-cloud-96x96.svg?component";
import happy from "assets/img/metabot-happy.svg?component";
import sad from "assets/img/metabot-sad.svg?component";
import cool from "assets/img/metabot-shades.svg?component";
import { useSetting } from "metabase/settings";

import Styles from "./MetabotLogo.module.css";

const urlByVariant = {
  happy,
  sad,
  cool,
  bug,
  cloud,
};

export type MetabotVariant = keyof typeof urlByVariant;

export interface MetabotLogoProps extends HTMLProps<SVGSVGElement> {
  className?: string;
  variant?: MetabotVariant;
  isCool?: boolean;
}

export const MetabotLogo = forwardRef(function MetabotLogo(
  { variant = "happy", className, isCool, ...rest }: MetabotLogoProps,
  ref: Ref<any>,
) {
  const MetabotComponent = urlByVariant[variant];
  const metabotName = useSetting("metabot-name");
  // `show-metabot` off: the character is drawn nowhere, not on the home page and not in a message.
  const showMetabot = useSetting("show-metabot");

  if (showMetabot === false) {
    return null;
  }

  return (
    <MetabotComponent
      className={cx(Styles.MetabotLogo, className)}
      {...rest}
      ref={ref}
      aria-label={metabotName}
      role="img"
    />
  );
});
